/**
 * Column linking rows of "Varad" and "Arestid" files together. Its values
 * are not returned by back-end, since they must be unique across all pages.
 *
 * NB: Same as EtisColumn::VARA_ID in back-end!
 */
export const ASSET_ID_COLUMN = 'VaraId';

/**
 * Column groups of ETIS import files "Varad" and "Arestid". ETIS can also
 * export the columns of both files into a single file, along with columns of
 * other groups, so these tell the columns of each file apart.
 *
 * NB: Same as column groups in EtisArrestExportRowFactory in back-end!
 */
export const ASSET_COLUMN_GROUPS = ['Vara'];
export const ARREST_COLUMN_GROUPS = ['VaraArest', 'VaraArest.Olek'];

/**
 * Column of ETIS import file. Group is written into the first header row
 * and name into the second header row of the file.
 */
export type EtisColumn = {
  group: string;
  name: string;
};

/**
 * A single arrest as rows of ETIS import files "Varad" and "Arestid",
 * keyed by ETIS column names. Values are already formatted by back-end.
 */
export type EtisArrestExportRow = {
  vara: Record<string, string>;
  arest: Record<string, string>;
};

/**
 * Response of ETIS arrests export for a single page of cases.
 *
 * NB: Same as returned by EtisArrestsExport.php in back-end!
 */
export type EtisArrestsExportPage = {
  columns: {
    vara: EtisColumn[];
    arest: EtisColumn[];
  };
  rows: EtisArrestExportRow[];
};
